module.exports = __webpack_public_path__ + "img/MEDIA095.0a540204.jpg";